import { call, put, takeLatest } from 'redux-saga/effects';

import { updateLayout as updateLayoutApi } from '../../services';
import { displayNotification, checkOnline, getNotification } from '../notifications';
import { COPY_LAYOUT, SAVE_LAYOUT, layoutSaved, NOTIFY_PAGE_CHANGES } from './actions';

export function* doSaveLayout(action) {
  const { siteId, layout } = action;

  try {
    const savedLayout = yield call(updateLayoutApi, siteId, layout.id, layout);
    yield put(layoutSaved(siteId, savedLayout));
    yield put(displayNotification(getNotification('saveLayout', 'success')(layout.id)));
  } catch (e) {
    console.error('Unable to save layout: ', e);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('saveLayout', 'error')(layout.id)));
  }
}

function* doNotifyCopyPage(action) {
  const { layout } = action;
  yield put(displayNotification(getNotification('duplicatePage', 'success')(layout.id)));
}

function* doNotifyPageChanges(action) {
  const { title } = action;
  yield put(displayNotification(getNotification(title, 'success')()));
}

export const sagas = [
  takeLatest(SAVE_LAYOUT, doSaveLayout),
  takeLatest(COPY_LAYOUT, doNotifyCopyPage),
  takeLatest(NOTIFY_PAGE_CHANGES, doNotifyPageChanges),
];
